import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

// Botão bonito e profissional pra alternar tema. Ícone anima suavemente:
// no tema claro mostra a lua (leva pro escuro), no escuro mostra o sol.
export default function ThemeToggle({ testid = "theme-toggle" }) {
  const { effective, toggle } = useTheme();
  const isDark = effective === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Ativar tema claro" : "Ativar tema escuro"}
      data-testid={testid}
      className="relative inline-flex items-center justify-center h-10 w-10 rounded-full border border-[hsl(var(--border))] bg-white dark:bg-[hsl(var(--card))] hover:bg-[hsl(var(--muted))] transition-colors group overflow-hidden"
    >
      <Sun
        className={`h-[18px] w-[18px] text-amber-500 transition-all duration-300 absolute ${
          isDark ? "rotate-0 scale-100 opacity-100" : "-rotate-90 scale-0 opacity-0"
        }`}
      />
      <Moon
        className={`h-[18px] w-[18px] text-slate-700 dark:text-slate-200 transition-all duration-300 absolute ${
          isDark ? "rotate-90 scale-0 opacity-0" : "rotate-0 scale-100 opacity-100"
        }`}
      />
    </button>
  );
}
